import React from 'react'
import { connect } from 'react-redux'
import { Route, Router, Link, Redirect, Switch } from 'react-router-dom'
import { Layout, Icon, Menu, Dropdown, Avatar, Tree, Input, AutoComplete, Col, Select, Button, Table, Badge, message } from 'antd';
import createHistory from 'history/createHashHistory'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

/*工具类*/
import { setHashUrl, setTransition } from './actions.js';
import getSize from './utils/getSize' //左侧菜单数据
import { getLoginUser } from './utils/NHCore' //获取登录用户信息

/*公用组件*/
import NHNavigationBar from './components/common/NHNavigationBar/index.js'
import Top from './containers/Header/index.js'
import Footer from './components/common/NHFooter/index'
import Error403 from './containers/Exception/403';

import Sstj from './containers/Sstj'
import TableIndex from './containers/Show/tableIndex'
// import Show from './containers/Show'
// import ShowZzsd from './containers/Show-zzsd'
// import ShowBgy from './containers/Show-bgy'

import Show from './containers/Show'
import ShowZzsd from './containers/Show-zzsd'
import ShowBgy from './containers/Show-bgy'
import ShowSszy from './containers/Show-sszy'//松山职业学院大屏页面
import ShowCsdl from './containers/Show-csdl'//长沙电力职业学院大屏页面
// import ShowGdnh from './containers/Show-gdnh'//广东南华工商职业学院大屏页面(已改为采用大屏模板进行切换)


/*模块*/
import Login from './components/Login/index'//登录


/*图片*/
import logo_expanded from './styles/images/logo-m.png';
import logo_collapsed from './styles/images/logo-s.png';

/********************以下是自己写的业务模块开始***************************/
import Welcome from './components/yxxc/index'
import ChooseBed from './components/chooseBed/index'
import StuPhotoMng from './components/stuPhotoMng/index'
import StudentPhotoMng from './components/studentPhotoMng/index'
import NewStudentMng from './components/newStudentMng/newStudentMng';
import MailingManagement from './components/mailingManagement/mailingManagement';
import BjqqManage from './components/bjqqManage/bjqqManage';
import ClassManagement from './components/classManagement/index'; 
import EditXhRuleManagement from './components/editXhRuleManagement/index';
import LcpzComponent from './components/lcgl/lcpz/index';
import HjglComponent from './components/lcgl/hjgl/index';
import HjfpComponent from './components/lcgl/hjfp/index';
import WbdStudent from './components/wbdStudentMng/wbdStudent';
import HjblcxIndex from './components/tjcx/hjblcx/index';
import ZzbdblcxIndex from './components/tjcx/zzbdblcx/index';      //自助报到办理查询
import XsblxxhzcxIndex from './components/tjcx/xsblxxhzcx/index';   //学生办理信息查询
import ShypIndex from './components/tjcx/shypcx/tyShypxc/index';      //生活用品查询
import JxfzIndex from './components/tjcx/jxfzcx/tyJxfzcx/index';      //军训服装查询
import XffzIndex from './components/tjcx/xffzcx/index';  //校服服装查询
import BdqkIndex from './components/tjcx/bdqkcx/index';      //报到情况查询
import ZsxxIndex from './components/tjcx/zsxxcx/index';      //住宿信息查询
import QueryStudents from "./components/tjcx/queryStudents/tyQueryStudents";
import Zytzxx from "./components/tjcx/zytzxx";      //专业调整统计
import Lstd from './components/swbl/TyLstd';//通用绿色通道
import Zytz from './components/swbl/zytz/index';
import HjblxqcxIndex from './components/tjcx/hjblxqcx/index';
import HjblywxIndex from './components/tjcx/hjblywxcx/index';
import ShwpglTab from './components/fwwgl/shwpgl/ShwpglTab';
import BdlcTab from './components/fwwgl/bdlc/BdlcTab';
import KsdhTab from './components/fwwgl/ksdh/KsdhTab';
import ZxwdTab from './components/fwwgl/zxwd/ZxwdTab';
import Lxfs from './components/fwwgl/lxfs/index';
import Sytp from './components/fwwgl/sytp/index';
import Zzbd from './components/fwwgl/zzbd/index';
import Ztwh from './components/fwwgl/ztwh/index';
import IndexComponet from './components/fwwgl/sylj/index';      //首页链接
import DhlmIndex from './components/fwwgl/dhlm/index';          //导航栏目
import XxfbTab from './components/fwwgl/xxfb/XxfbTab';
import Spgl from './components/fwwgl/spgl/Video'; //视频管理
import BdglTab from './components/xxcj/bdgl/index';             //表单管理
import ZdglTab from './components/xxcj/zdgl/index';             //字段管理
import Lstdblcx from './components/tjcx/lstdblcx/index';        //绿色通道办理查询
import Face from './components/face';                           //绿色通道办理查询
import Success from './components/face/success/index';          //刷脸成功
import Xsxxcjcx from './components/tjcx/xsxxcjcx/tyXsxxcjcx';        //学生信息采集查询
import Xsjfxxcx from './components/tjcx/xsjfxxcx/xsjfxxcxMenuConfig';        //学生缴费信息查询
import Xsjfcxtj from './components/tjcx/xsjfcxtj/index';
import Jfcssz from './components/zxjfgl/jfcssz/index';          //缴费参数设置
import Jffagl from './components/zxjfgl/jffagl/index';          //缴费方案管理
// import Rlsb from './components/face/rlsbView';
import Rlsb from './components/face/scan/index';
import Bdtjcx from './components/tjcx/bdtjcx/tyBdtjcx';         //通用报到统计查询
import BdtjcxFilterByCollege from './components/tjcx/bdtjcxFilterByCollege/index'; //报到统计查询（按登录人所在部门进行筛选）
import ZzBdtjcx from './components/tjcx/zzbdtjcx/tyZzbdtjcx';   //通用自助报到环节办理统计
import TestPicturesWall from './components/xxcj/pictureswall/PicturesWallContainer';
import Sszsxxcx from './components/tjcx/sszsxxcx/index';
import Ywxblcx from './components/tjcx/ywxblcx/index';
import LqcxxxwhComponent from './components/lqcxxxwh/index';
import Sjhmwh from './components/sjhmwh/index';             // 手机号码维护
import Sjhmhz from './components/tjcx/sjhmhz/index';        // 已选手机号码信息汇总
import Rlsbxxcx from './components/tjcx/rlsbxxcx/index';        // 人脸识别信息查询
import ScjtRlsbxxcx from './components/tjcx/scjtRlsbxxcx/index';        // 人脸识别信息查询
import Zyzxx from './components/zyzxx/index'
import Dtzbwh from "./components/fwwgl/dtzbwh/index";       // 地图坐标维护
import Sfzs from './components/swbl/sfzs/index' //是否住宿（江汉艺术学院）
import ChangeMajorStatic from './components/changeMajorStaic/index.js';
import DistributeClass from './components/distributeClass/index.js';   //学生班级分配
/********************以上是自己写的业务模块结束***************************/
/**图标 */
const userIconImg = require.context("./styles/icons", true, /(\.gif|\.jpeg|\.png|\.jpg|\.bmp)/);
const { Header, Sider, Content } = Layout;
const history = createHistory()

@connect((state) => {
    const { hashUrl, login } = state
    return { hashUrl, login }
})
export default class TotalRoutes extends React.Component {
    constructor() {
        super()
        this.state = {
            collapsed: false,
            expandedKeys: [],
            transition: true,
            onClick: false,
            openKeys: ['sub1'],
            selectedKeys: ['yxxc'],
            nextUrl: '/yxxc',
            fwmc: '迎新管理',
            iconData: {},
        }
    }

    componentWillMount() {
        window.addEventListener('hashchange', this.hashChange)

        let dispatch = this.props.dispatch
        let menu = window.location.href.split('#')[1].split('/');
        this.loginSkip(menu, dispatch);
    }

    componentDidMount() {
        //图标
        let imgIconData = userIconImg.keys().map(userIconImg);
        let iconData = {};
        let imgArray = userIconImg.keys().map((imgName, key) => {
            iconData[imgName] = imgIconData[key];
        });
        this.setState({ iconData: iconData });
        //图标
        this.changeIcon();
    };

    //修改icon
    changeIcon = () => {
        let link = document.head.querySelector("link[rel=icon]");
        let href = window.location.href;
        link.href = href.substring(0, href.indexOf('/', 8))+'/front/zhxg-unauth/xtglSchoolMng/downloadSchoolPictureByType?type=ico';
    };

    componentWillUpdate(newProps) {
        //只有获取了登录数据之后，才需要判断是否登录等操作
        let menu = window.location.href.split('#')[1].split('/');
        const initState = getLoginUser();
        const menus = initState.menus;
        let nextUrl = '/home';
        if (menus.length > 0) {
            nextUrl = menus[0].url;
            if (menus[0].children && menus[0].children.length > 0) {
                nextUrl = menus[0].children[0].url;
            }
        }
        //如果已经登录了
        if (menu[1] && menu[1] == 'login' && initState.userId) {
            location.href = '#' + nextUrl;
        } else if (!menu[1] && initState.userId) {
            if (nextUrl != this.state.nextUrl) {
                this.setState({ "nextUrl": nextUrl });
            }
        } else if (!menu[1] && !initState.userId) {
            if ("/login" != this.state.nextUrl) {
                this.setState({ "nextUrl": "/login" });
            }
        } else if (!initState.userId) {
            location.href = '#/login';
        }
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', () => { })
    }

    /**
     * 当前已经登录时需要做的处理
     * @param menu
     * @param dispatch
     */
    loginSkip = (menu, dispatch) => {
        const initState = getLoginUser();
        const menus = initState.menus;
        let nextUrl = '/home';
        if (menus.length > 0) {
            nextUrl = menus[0].url;
            if (menus[0].children && menus[0].children.length > 0) {
                nextUrl = menus[0].children[0].url;
            }
        }
        //如果还没有登录,则跳转到登录界面
        if (!initState.userId) {
            history.push('/login');
            /*this.setState({"nextUrl":"/login"});
            if(menu[1]){
                location.href='#/login';
            }*/
        } else {
            if (menu[1] && menu[1] != 'login') {
                this.currentUrl = window.location.href.split('#')[1]
                dispatch(setHashUrl({ oldUrl: this.oldUrl, currentUrl: window.location.href.split('#')[1] }))
            } else {
                this.setState({ "nextUrl": nextUrl });
                if (menu[1]) {
                    location.href = '#' + nextUrl;
                }
                dispatch(setHashUrl({ oldUrl: this.oldUrl, currentUrl: nextUrl }))
            }
        }
        let curUrl = window.location.href.split('#')[1];
        if (curUrl == '/') {
            curUrl = nextUrl;
        }
        let leftMenu = initState.menus ? initState.menus : [];
        //获取当前需要默认展开哪个一级菜单
        let newOpenkey = [];
        leftMenu.map((item, index) => {
            if (item.children) {
                item.children.map((itemC) => {
                    if (itemC.url == curUrl) {
                        newOpenkey.push(item.key);
                        this.setState({
                            openKeys: newOpenkey
                        })
                    }
                })
            }
        })
    }

    oldUrl = '/'
    currentUrl = '/'

    hashChange = (ev) => {
        const dispatch = this.props.dispatch
        let hashUrl = null;
        if (ev.oldURL) {
            hashUrl = { oldUrl: ev.oldURL.split('#')[1], currentUrl: ev.newURL.split('#')[1] }
        } else {
            this.oldUrl = this.currentUrl
            this.currentUrl = window.location.href.split('#')[1]
            hashUrl = { oldUrl: this.oldUrl, currentUrl: this.currentUrl }
        }
        dispatch(setTransition({ transition: 'none' }))
        dispatch(setHashUrl(hashUrl))
    }

    changeTransition = (transition) => {
        this.setState({ transition: transition })
    }

    onOpenChange = (openKeys) => {
        const state = this.state;
        const latestOpenKey = openKeys.find(key => !(state.openKeys.indexOf(key) > -1));
        const latestCloseKey = state.openKeys.find(key => !(openKeys.indexOf(key) > -1));
        let nextOpenKeys = [];
        if (latestOpenKey) {
            nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
        }
        if (latestCloseKey) {
            nextOpenKeys = this.getAncestorKeys(latestCloseKey);
        }
        this.setState({ openKeys: nextOpenKeys });
    }
    getAncestorKeys = (key) => {
        const map = { key };
        return map[key] || [];
    }

    //菜单收缩
    toggle = () => {
        // this.leftnav.toggle()
        this.setState({
            collapsed: !this.state.collapsed,
            openKeys: []
        });
    }



    render() {

        const { SubMenu } = Menu;
        const dependUrl = location.pathname;

        let curUrls = window.location.href.split('#')[1];
        const initState = getLoginUser();
        let leftMenu = initState.menus ? initState.menus : [];
        let breadcrumbList = [];
        if (curUrls == '/') {
            curUrls = this.state.nextUrl;
        }
        if (curUrls != '/login' && !curUrls.startsWith('/rlsb')) {//如果访问路径存在，则判断这个路径是否有访问的权限，如果没有访问权限，则显示403界面
            let curUrl = "/" + curUrls.split("/")[1];
            let ishaveAuth = false;
            for (let i = 0; i < leftMenu.length; i++) {
                if (leftMenu[i].children) {
                    for (let j = 0; j < leftMenu[i].children.length; j++) {
                        if (leftMenu[i].children[j].url == curUrl) {
                            ishaveAuth = true;
                            breadcrumbList.push(leftMenu[i], leftMenu[i].children[j]);
                        }
                    }
                } else {
                    if (leftMenu[i].url == curUrl) {
                        ishaveAuth = true;
                        breadcrumbList.push(leftMenu[i]);
                    }
                }
            }
            //如果是已经登录，且访问了没有权限的菜单，则跳转到403界面
            if (!ishaveAuth && initState.userId) {
                location.href = '#' + this.state.nextUrl;
            }
        }
        return (
            <Router history={history}>
                <Route render={({ location }) => {
                    return (
                        <CSSTransitionGroup
                            transitionName={this.props.hashUrl.transition}
                            transitionEnter={true}
                            transitionLeave={true}
                            transitionEnterTimeout={500}
                            transitionLeaveTimeout={500}
                        >
                            <div key={location.pathname == '/login' ? 'login' : 'content'} style={{ width: '100%', height: '100%' }}>
                                <Switch location={location}>
                                    {/* 只有获取过登录用户数据之后，才能进行操作*/}
                                    <Route location={location} path="/login" render={() => (<Login />)} />
                                    <Route location={location} exact path="/" render={() => (this.state.nextUrl == '/login' ? <Login /> : <Redirect to={this.state.nextUrl} />)} />
                                    <Route location={location} path="/rlsb/:pkid/:ip" component={Rlsb} />
                                    <Route location={location} exact path="/show" render={() => <Sstj   />} /> 
                                    <Route location={location} exact path="/show/:pkid/:csbz"  component={Sstj}   />
                                    {/* <Route location={location} path="/show" render={() => <Show />} />
                                    <Route location={location} path="/show-zzsd" render={() => <ShowZzsd />} />
                                    <Route location={location} path="/bgy-show" render={() => <ShowBgy />} /> */}
                                    <Route location={location} path="/bgy-show" render={() => <ShowBgy />} />
                                    <Route location={location} path="/sszy-show" render={() => <ShowSszy />} />
                                    <Route location={location} path="/csdl-show" render={() => <ShowCsdl />} />
                                    {/*<Route location={location} path="/gdnh-show" render={() => <ShowGdnh />} />*/} 
                                    {/* 刷脸报到成功 */}
                                    <Route location={location} path="/success" render={() => <Success location={location} />} />
                                    <Route location={location} render={({ location }) => {
                                        return (
                                            <div style={{ height: '100%' }}>
                                                <CSSTransitionGroup
                                                    transitionName={this.props.hashUrl.transition}
                                                    transitionEnter={true}
                                                    transitionLeave={true}
                                                    transitionEnterTimeout={400}
                                                    transitionLeaveTimeout={400}
                                                >
                                                    <div style={{ height: '100%' }} >
                                                    {/* Scrollbars */}
                                                        <Layout style={{ height: '100%' }}>
                                                            {/*左侧菜单栏*/}
                                                            <Sider
                                                                trigger={null}
                                                                collapsible
                                                                collapsed={this.state.collapsed}
                                                                width={255}
                                                            >
                                                                <div className="logo">
                                                                    <img style={{ maxWidth: 40, maxHeight: 40 }} src={'api/zhxg-xtgl/schoolMng/downloadSchoolPictureByType?type=logo'} onError={(e) => {
                                                                        e.target.src = logo_collapsed;
                                                                    }} />
                                                                    {!this.state.collapsed &&
                                                                        <span><b>
                                                                            {this.state.fwmc}
                                                                        </b></span>}
                                                                </div>
                                                                <Menu theme="dark"
                                                                    mode="inline"
                                                                    defaultSelectedKeys={['1']}
                                                                    openKeys={this.state.openKeys}
                                                                    onOpenChange={this.onOpenChange}
                                                                    selectedKeys={[location.pathname.split('/')[1]]}
                                                                    onClick={(item) => {
                                                                    }}
                                                                >
                                                                    {leftMenu.map((item, index) => {
                                                                        if (item.children && item.children != '') {
                                                                            let htmlct = [];
                                                                            let menuItem = item.children.map((itemM, index) => {
                                                                                return <Menu.Item key={itemM.key}>
                                                                                    <Link key={1} to={itemM.url} >
                                                                                        {this.state.iconData[itemM.icon] ? <img className='anticon' src={this.state.iconData[itemM.icon]} style={{ width: '14px', height: '14px', marginRight: '10px' }} /> : <Icon type={itemM.icon} />}
                                                                                        <span>{itemM.name}</span>
                                                                                    </Link>
                                                                                    </Menu.Item>
                                                                            })
                                                                            htmlct.push(<SubMenu key={item.key} title={<span>
                                                                                {this.state.iconData[item.icon] ? <img className='anticon' src={this.state.iconData[item.icon]} style={{ width: '14px', height: '14px', marginRight: '10px' }} /> : <Icon type={item.icon} />}
                                                                                <span>{item.name}</span></span>}>{menuItem}</SubMenu>)
                                                                            return htmlct
                                                                        } else {
                                                                            return <Menu.Item key={item.key}>
                                                                                <Link key={1} to={item.url} >
                                                                                    {this.state.iconData[item.icon] ? <img className='anticon' src={this.state.iconData[item.icon]} style={{ width: '14px', height: '14px', marginRight: '10px' }} /> : <Icon type={item.icon} />}
                                                                                    <span>{item.name}</span>
                                                                                </Link>
                                                                            </Menu.Item>
                                                                        }
                                                                    })}
                                                                    {/*  {leftMenu.map((item, index) => {
                                                                        if (item.children && item.children != '') {
                                                                            let htmlct = [];
                                                                            let menuItem = item.children.map((itemM, index) => {
                                                                                return <Menu.Item key={itemM.key}><Link key={1} to={itemM.url} ><Icon type={itemM.icon} /> <span>{itemM.name}</span></Link></Menu.Item>
                                                                            })
                                                                            htmlct.push(<SubMenu key={item.key} title={<span><Icon type={item.icon} /><span>{item.name}</span></span>}>{menuItem}</SubMenu>)
                                                                            return htmlct
                                                                        }else{
                                                                            return <Menu.Item key={item.key}><Link key={1} to={item.url} ><Icon type={item.icon} /> <span>{item.name}</span></Link></Menu.Item>
                                                                        }
                                                                    })}*/}
                                                                </Menu>
                                                            </Sider>
                                                            <Layout>
                                                                {/*头部公用组件*/}
                                                                <Top collapsed={this.state.collapsed} toggle={this.toggle} />
                                                                <NHNavigationBar breadcrumbList={breadcrumbList} />
                                                                <Content style={{ height: getSize().windowH - 68 }}>
                                                                    {/*页面显示区域*/}
                                                                    <Switch location={location} key={location.pathname.split('/')[1]}>
                                                                        <Route location={location} path="/403" render={() => <Error403 location={location} />} />
                                                                        <Route location={location} path="/yxxc" render={() => <Welcome location={location} />} />
                                                                        <Route location={location} path="/xzcw" render={() => <ChooseBed location={location} />} />
                                                                        <Route location={location} path="/xszpgl" render={() => <StuPhotoMng location={location} />} />
                                                                        <Route location={location} path="/studentPhotoMng" render={() => <StudentPhotoMng location={location} />} />
                                                                        <Route location={location} path="/newStudent" render={() => <NewStudentMng location={location} />} />
                                                                        <Route location={location} path="/mailingManagement" render={() => <MailingManagement location={location} />} />
                                                                        <Route location={location} path="/bjqqManage" render={() => <BjqqManage location={location} />} />
                                                                        <Route location={location} path="/classManagement" render={() => <ClassManagement location={location} />} /> 
                                                                        <Route location={location} path="/editXhRuleManagement" render={() => <EditXhRuleManagement location={location} />} />  
                                                                        <Route location={location} path="/lcpz" render={() => <LcpzComponent location={location} />} />
                                                                        <Route location={location} path="/hjgl" render={() => <HjglComponent location={location} />} />
                                                                        <Route location={location} path="/hjfp" render={() => <HjfpComponent location={location} />} />
                                                                        <Route location={location} path="/wbdStudent" render={() => <WbdStudent location={location} />} />
                                                                        <Route location={location} path="/hjblcx" render={() => <HjblcxIndex location={location} />} />
                                                                        <Route location={location} path="/zzbdblcx" render={() => <ZzbdblcxIndex location={location} />} />
                                                                        <Route location={location} path="/xsblxxhzcx" render={() => <XsblxxhzcxIndex location={location} />} />
                                                                        <Route location={location} path="/shypcx" render={() => <ShypIndex location={location} />} />
                                                                        <Route location={location} path="/jxfzcx" render={() => <JxfzIndex location={location} />} />
                                                                        <Route location={location} path="/xffzcx" render={() => <XffzIndex location={location} />} />
                                                                        <Route location={location} path="/bdqkcx" render={() => <BdqkIndex location={location} />} />
                                                                        <Route location={location} path="/zsxxcx" render={() => <ZsxxIndex location={location} />} />
                                                                        <Route location={location} path="/xsxxcx" render={() => <QueryStudents location={location} />} />
                                                                        <Route location={location} path="/lstd" render={() => <Lstd location={location} />} />
                                                                        <Route location={location} path="/sszsxxcx" render={() => <Sszsxxcx location={location} />} />
                                                                        <Route location={location} path="/ywxblcx" render={() => <Ywxblcx location={location} />} />

                                                                        <Route location={location} path="/zytz" render={() => <Zytz location={location} />} />
                                                                        <Route location={location} path="/hjblxqcx" render={() => <HjblxqcxIndex location={location} />} />
                                                                        <Route location={location} path="/hjblywxcx" render={() => <HjblywxIndex location={location} />} />
                                                                        <Route location={location} path="/shwpgl" render={() => <ShwpglTab location={location} />} />
                                                                        <Route location={location} path="/bdlc" render={() => <BdlcTab location={location} />} />
                                                                        <Route location={location} path="/ksdh" render={() => <KsdhTab location={location} />} />
                                                                        <Route location={location} path="/zxwd" render={() => <ZxwdTab location={location} />} />
                                                                        <Route location={location} path="/lxfs" render={() => <Lxfs location={location} />} />
                                                                        <Route location={location} path="/sytp" render={() => <Sytp location={location} />} />
                                                                        <Route location={location} path="/zzbd" render={() => <Zzbd location={location} />} />
                                                                        <Route location={location} path="/ztwh" render={() => <Ztwh location={location} />} />
                                                                        <Route location={location} path="/sylj" render={() => <IndexComponet location={location} />} />
                                                                        <Route location={location} path="/dhlm" render={() => <DhlmIndex location={location} />} />
                                                                        <Route location={location} path="/xxfb" render={() => <XxfbTab location={location} />} />
                                                                        <Route location={location} path="/bdgl" render={() => <BdglTab location={location} />} />
                                                                        <Route location={location} path="/zdgl" render={() => <ZdglTab location={location} />} />
                                                                        <Route location={location} path="/lstdblcx" render={() => <Lstdblcx location={location} />} />
                                                                        <Route location={location} path="/face" render={() => <Face location={location} />} />
                                                                        <Route location={location} path="/spgl" render={() => <Spgl location={location} />} />

                                                                        <Route location={location} path="/xsxxcjcx" render={() => <Xsxxcjcx location={location} />} />
                                                                        <Route location={location} path="/xsjfxxcx" render={() => <Xsjfxxcx location={location} />} />
                                                                        <Route location={location} path="/xsjfcxtj" render={() => <Xsjfcxtj location={location} />} />
                                                                        <Route location={location} path="/bdtjcx" render={() => <Bdtjcx location={location} />} />
                                                                        <Route location={location} path="/bdtjcxFilterByCollege" render={() => <BdtjcxFilterByCollege location={location} />} />
                                                                        <Route location={location} path="/zzbdtjcx" render={() => <ZzBdtjcx location={location} />} />
                                                                        <Route location={location} path="/testPicturesWall" render={() => <TestPicturesWall location={location} />} />
                                                                        <Route location={location} path="/jfcssz" render={() => <Jfcssz location={location} />} />
                                                                        <Route location={location} path="/jffagl" render={() => <Jffagl location={location} />} />
                                                                        <Route location={location} path="/lqcxxxwh" render={() => <LqcxxxwhComponent location={location} />} />
                                                                        <Route location={location} path="/sjhmwh" render={() => <Sjhmwh location={location} />} />
                                                                        <Route location={location} path="/sjhmhz" render={() => <Sjhmhz location={location} />} />
                                                                        <Route location={location} path="/rlsbxxcx" render={() => <Rlsbxxcx location={location} />} />
                                                                        <Route location={location} path="/scjtRlsbxxcx" render={() => <ScjtRlsbxxcx location={location} />} />
                                                                        <Route location={location} path="/zyzxx" render={() => <Zyzxx location={location} />} />
                                                                        <Route location={location} path="/dtzbwh" render={() => <Dtzbwh location={location} />} />
                                                                        <Route location={location} path="/sfzs" render={() => <Sfzs location={location} />} />
                                                                        <Route location={location} path="/changeMajorStatic" render={() => <ChangeMajorStatic location={location} />} />
                                                                        <Route location={location} path="/distributeClass" render={()=><DistributeClass location={location}/>} />
                                                                        <Route location={location} path="/zytzxx" render={()=><Zytzxx location={location}/>} />
                                                                        <Route location={location} path="/showTable" render={() => <TableIndex location={location} />} />
                                                                    </Switch>
                                                                </Content>
                                                                {/* <Footer /> */}
                                                            </Layout>
                                                        </Layout>
                                                    </div>
                                                </CSSTransitionGroup>
                                            </div>
                                        )
                                    }} />
                                </Switch>
                            </div>
                        </CSSTransitionGroup>
                    )
                }} />
            </Router>
        );
    }

}



// WEBPACK FOOTER //
// ./TotalRoutes.js